// Display labels for the school member API's enums (buzz-one-backend
// src/modules/akademy/schools/API.md, "Shared types").

// The membership role a member is added with. Kept apart from the licence / profile
// roles (`SCHOOL_*`, `EDUCATOR_*`, `SKILLUP_*`), which arrive with a licence.
export const MEMBERSHIP_ROLE_OPTIONS = [
  { value: 'ADMIN', label: 'Admin' },
  { value: 'CO_ORDINATOR', label: 'Coordinator' },
  { value: 'TEACHER', label: 'Teacher' },
  { value: 'PARENT', label: 'Parent' },
];

export const ROLE_FILTER_OPTIONS = [
  { value: '', label: 'All roles' },
  ...MEMBERSHIP_ROLE_OPTIONS,
];

export const INVITE_STATUS_OPTIONS = [
  { value: '', label: 'Any licence status' },
  { value: 'YET_TO_INVITE', label: 'Yet to invite' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'ACCEPTED', label: 'Accepted' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'REVOKED', label: 'Revoked' },
  { value: 'EXPIRED', label: 'Expired' },
];

const ROLE_LABELS = {
  ADMIN: 'Admin',
  CO_ORDINATOR: 'Coordinator',
  TEACHER: 'Teacher',
  PARENT: 'Parent',
  SCHOOL_ADMIN: 'School Admin',
  SCHOOL_CO_ORDINATOR: 'School Coordinator',
  SCHOOL_TEACHER: 'School Teacher',
  SCHOOL_PARENT: 'School Parent',
  EDUCATOR_ADMIN: 'Educator Admin',
  EDUCATOR_TEACHER: 'Educator Teacher',
  EDUCATOR_PARENT: 'Educator Parent',
  SKILLUP_ADMIN: 'SkillUp Admin',
  SKILLUP_LEARNER: 'SkillUp Learner',
};

export const roleLabel = (role) => ROLE_LABELS[role] || role;

const STATUS_LABELS = Object.fromEntries(
  INVITE_STATUS_OPTIONS.filter(({ value }) => value).map(({ value, label }) => [
    value,
    label,
  ])
);

export const inviteStatusLabel = (status) => STATUS_LABELS[status] || status;
